<template>
	<v-dialog v-model="dialog" persistent max-width="700px">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				v-bind="attrs"
				v-on="on"
				color="red"
				outlined
				dark
				@click="open()"
				:loading="item.processing"
			>
				{{ $t("label.decline") }}
			</v-btn>
		</template>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.declined_reason") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout row wrap>
								<v-flex xs12>
									<ValidationProvider
										name="cancel_reason"
										rules="required"
										v-slot="{ errors, valid }"
									>
										<v-textarea
											v-model="item.cancel_reason"
											:label="$t('title.declined_reason')"
											:error-messages="errors"
											:append-icon="
												valid ? 'mdi-check' : null
											"
										></v-textarea>
									</ValidationProvider>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text @click="close()">
							<v-icon left>mdi-close</v-icon>
							{{ $t("Close") }}
						</v-btn>
						<v-btn
							color="primary"
							@click.native="submit(order)"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("label.decline") }}</v-btn
						>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-dialog>
</template>

<script>
export default {
	props: ["value", "order"],
	data() {
		return {
			dialog: false,
		};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		open() {
			this.dialog = true;
		},

		close() {
			this.dialog = false;
		},

		submit(order) {
			try {
				this.item.post(
					this.$route("tenant.orders.mark_as_declined", {
						tenant: this.$page.props.tenant.id,
						order: order.uuid,
					})
				);
			} finally {
				this.close();
			}
		},
	},
};
</script>